import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { compose } from 'redux'
import Input from 'shared-web/src/components/Input'

import withOAuthConnectionStatus from './withOAuthConnectionStatus'

const CalendarField = (props) => {
  if (!props.isConnected) {
    return <Input {...props}/>
  }

  return (
    <Input
      {...props}
      value={''}
      onChange={null}
      disabled
      placeholder="Your Google Calendar is connected"
    />
  )
}

export default compose(
  withOAuthConnectionStatus,
)(CalendarField)




// WEBPACK FOOTER //
// ./src/scripts/components/settings/UserProfile/Sections/Profile/ContactInfo/CalendarField.js